import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";

import {
  TextField,
  InputAdornment,
  useMediaQuery,
  MenuItem,
  Box,
} from "@mui/material";
import { s3baseUri } from "../../config/config";
import { get_all_sectors_by_client_type } from "../../DAL/TalentSourceAPI/TalentSourceApi";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { useSnackbar } from "notistack";
import { show_proper_words } from "../../utils/Constant";
import { useIds } from "../../hook/AdminContext";
import PartnersSkeleton from "../../components/loader/PartnerTypeSkelton";
import { clients_types_api } from "../../DAL/clientTypes/ClientTpes";
import ClientsCard from "./components/ClientsCard";
import ClientHoverImageCard from "./components/ClientHoverImageCard";

export default function ClientTypes() {
  const navigate = useNavigate();
  const { setBreadCrumb, findId } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();

  const [clients, setClients] = useState([]);
  const [sectors, setSectors] = useState([]);

  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)");
  const { type_slug, source_slug, sector_slug } = useParams();
  const [selectedSector, setSelectedSector] = useState(sector_slug);

  const fetchTabs = async () => {
    const response = await get_all_sectors_by_client_type("", 50, 0, type_slug);
    if (response.code === 200) {
      setSectors(response?.data.sectors);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  const handleNavigateDetails = (item) => {
    navigate(
      `/${source_slug}/type/${type_slug}/detail/${sector_slug}/${item?._id}`
    );
  };

  const fetchCategories = async (id, sectorId, isLoading = false, page = 1) => {
    if (!isLoading) setLoading(true);
    if (isLoading) setIsLoadingMore(true);

    if (!sectorId) {
      sectorId = selectedSector;
    }
    if (selectedSector === "all") {
      sectorId = "";
    }

    try {
      const response = await clients_types_api(
        0, // API expects 0-based page
        200, // limit
        searchText,
        source_slug,
        sectorId,
        type_slug
      );
      if (response.code === 200) {
        setTotalPages(response?.totalPages);
        setTotal(response?.total);

        if (isLoading) {
          setPageNumber((prev) => prev + 1);
        } else {
          setPageNumber(response.page || page);
        }

        if (isLoading) {
          setClients((prev) => [...prev, ...response?.clients]);
        } else {
          setClients(response?.clients);
        }
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
      }
    } catch (error) {
      // enqueueSnackbar("Failed to fetch data.", { variant: "error" });
    }

    setLoading(false);
    setIsLoadingMore(false);
  };
  const loadMoreData = () => {
    if (isLoadingMore || pageNumber >= totalPages) return;
    fetchCategories(findId, selectedSector, true, pageNumber + 1);
  };

  const getTypeTitle = (slug) => {
    const titleMap = {
      clients: "Clients",
      "industry-partners": "Industry Partners",
      suppliers: "Industry Suppliers",
      partners: "Agency Partners",
    };
    const result = titleMap[slug] || show_proper_words(slug);
    return result;
  };

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(source_slug)}`,
        path: `/home`,
        active: false,
      },
      {
        name: getTypeTitle(type_slug),
        path: `/${source_slug}/type/${type_slug}`,
        active: true,
      },
      {
        name: getTypeTitle(sector_slug),
        path: `/${source_slug}/type/${type_slug}/${sector_slug}`,
        active: true,
      },
    ]);
  }, [source_slug, type_slug]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSectorChange = (event) => {
    setSelectedSector(event.target.value);
  };

  // Single useEffect to handle all data fetching
  useEffect(() => {
    // Reset data when type_slug changes
    if (type_slug) {
      setSelectedSector(sector_slug);
      setSearchText("");
      setClients([]);
    }

    // Fetch tabs and clients
    // fetchTabs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type_slug, sector_slug]);

  useEffect(() => {
    let timeoutId;

    if (searchText) {
      // Debounced fetch on search
      timeoutId = setTimeout(() => {
        fetchCategories(findId, selectedSector);
      }, 1500);
    } else {
      // Immediate fetch on initial render, sector, or type changes
      fetchCategories(findId, selectedSector);
    }

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, selectedSector, type_slug, sector_slug]);

  return (
    <div className="container-fluid mt-3">
      <div className="row mt-0">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div className=" col-md-5 heading-main">
            <h3 className="ms-0">{getTypeTitle(sector_slug)}</h3>
          </div>

          <div className="col-md-7 d-flex justify-content-center justify-content-md-end align-items-center gap-2">
            {/* {sectors?.length > 0 ? (
              <TextField
                select
                label="Select Sector"
                value={selectedSector}
                onChange={handleSectorChange}
                sx={{
                  width: isMobile ? 370 : 300,
                  marginTop: isMobile ? "16px" : "",
                  minWidth: "282px !important",
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 180,
                        minWidth: isMobile ? "90%" : 282,
                      },
                    },
                  },
                }}
              >
                <MenuItem value="all">All</MenuItem>
                {sectors.map((sector) => (
                  <MenuItem key={sector._id} value={sector?.slug}>
                    <Box
                      sx={{
                        maxWidth: "240px", // text cut hone se pehle ki max width
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={sector.title} // hover pe pura text show hoga
                    >
                      {sector.title}
                    </Box>
                  </MenuItem>
                ))}
              </TextField>
            ) : null} */}

            <TextField
              variant="outlined"
              placeholder="Search..."
              className="mui-dropdown search-field"
              value={searchText}
              onChange={handleSearchChange}
              sx={{
                width: isMobile ? 360 : 300,
                marginTop: isMobile ? "16px" : "",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 21 }} />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>

        {/* Partners Grid */}
        {loading ? <PartnersSkeleton /> : ""}
        {clients && clients?.length > 0 ? (
          <div className="d-grid gap-3 grid-template tw-my-3 pb-5">
            {clients.map((item, index) => (
              <>
                <ClientHoverImageCard
                  client={item}
                  source_slug={source_slug}
                  type_slug={type_slug}
                  handleNavigateDetails={handleNavigateDetails}
                />
              </>
            ))}
          </div>
        ) : (
          <div className="col-12">
            <>
              {clients?.length === 0 && !loading && (
                <RecordNotFound title="No Partners" />
              )}
            </>
          </div>
        )}

        {/* Load More Button */}
        {clients?.length > 0 && pageNumber < totalPages && (
          <div className="col-12 mt-3 text-center">
            <button
              className="btn btn-primary"
              onClick={loadMoreData}
              disabled={isLoadingMore}
            >
              {isLoadingMore ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </>
              ) : (
                `Load More `
              )}
            </button>
          </div>
        )}

        {/* Loading More Indicator */}
        {isLoadingMore && (
          <div className="col-12 mt-2 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading more...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
